<template>
  <div>
    <h4>Edit Academy Course</h4>
    <form @submit.prevent="submit" v-if="! loading">
      <div class="form-group">
        <label>Course Title</label>
        <input
          type="text"
          placeholder="Course Title"
          v-model="course.title"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label>Sort Order</label>
        <input
          type="text"
          placeholder="Sort Order"
          v-model="course.sort"
          class="form-control"
        />
      </div>
      <div class="form-group">
        <label>About this course</label>
        <editor
          api-key="no-api-key"
          v-model="course.about"
          :init="{
            height: 500,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar:
              'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help',
          }"
        />
      </div>
      <div class="form-group">
        <button class="btn btn-primary">Save</button>
      </div>
    </form>

    <loading v-if="loading" />
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch()
  },

  data() {
    return {
      course: {},
      editor_options: {
        height: "500px"
      },
      loading: true
    };
  },

  methods: {
    fetch() {
      this.loading = true

      this.$axios
        .get(`/api/v1/admin/academy/${this.$route.params.id}/courses/${this.$route.params.course_id}`)
        .then((response) => {
          this.course = response.data.course;
          this.loading = false;
        });
    },

    submit() {
      this.loading = true

      this.$axios
        .put(`/api/v1/admin/academy/${this.$route.params.id}/courses/${this.$route.params.course_id}`, this.course)
        .then(() => {
          this.loading = false
          this.$router.push({
            name: 'admin.academy.courses.show'
          });
        });
    },
  },
};
</script>